import React from "react";
import { Link } from "react-router-dom";
import { formatPriceShort } from "../../lib/price";

/**
 * Experience card — 3:4 portrait image, eyebrow city label, Playfair title,
 * Cormorant italic one-liner, brass hairline that grows on hover.
 */
export default function ExperienceCard({ experience, lang }) {
  const e = experience;
  const priceLabel = formatPriceShort(e, lang || "en");
  return (
    <Link
      to={`/experiences/${e.slug}`}
      className="group block"
      data-testid={`experience-card-${e.slug}`}
    >
      <div className="relative w-full overflow-hidden bg-mist" style={{ aspectRatio: "3 / 4" }}>
        {e.hero_image && (
          <picture>
            {/\.jpe?g$/i.test(e.hero_image) && (
              <source srcSet={e.hero_image.replace(/\.jpe?g$/i, ".webp")} type="image/webp" />
            )}
            <img
              src={e.hero_image}
              alt={e.title}
              loading="lazy"
              decoding="async"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-1200 ease-out group-hover:scale-[1.04]"
              onError={(evt) => { evt.currentTarget.style.display = "none"; }}
            />
          </picture>
        )}
      </div>
      <p className="eyebrow text-charcoal/60 mt-5" style={{ fontSize: "10px" }}>
        {e.city_label}
      </p>
      <h3
        className="font-display text-charcoal mt-2 leading-tight text-balance"
        style={{ fontSize: "clamp(1.35rem, 1.8vw, 1.5rem)" }}
        data-testid={`experience-name-${e.slug}`}
      >
        {e.title}
      </h3>
      <p
        className="italic-quote text-charcoal/75 mt-2 leading-snug text-pretty"
        style={{ fontSize: "clamp(1rem, 1.1vw, 1.125rem)" }}
      >
        {e.subtitle}
      </p>
      {priceLabel && (
        <p
          className="eyebrow text-vdv-grey-alt mt-3"
          style={{ fontSize: "11px", letterSpacing: "0.18em" }}
          data-testid={`experience-price-${e.slug}`}
        >
          {priceLabel}
        </p>
      )}
      <span
        className="block h-px bg-brass mt-4 w-8 transition-all duration-700 group-hover:w-20"
        aria-hidden
      />
    </Link>
  );
}
